import { useEffect, useRef } from 'react'

/**
 * Rejoue `reset` quand le navigateur rend la page depuis son cache après un
 * retour arrière (bfcache) : un bouton laissé « en cours » avant de quitter le
 * site (paiement, portail Stripe) resterait figé sinon.
 */
export function useResetOnPageShow(reset: () => void): void {
  const latest = useRef(reset)
  useEffect(() => {
    latest.current = reset
  })

  useEffect(() => {
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) latest.current()
    }
    window.addEventListener('pageshow', onPageShow)
    return () => window.removeEventListener('pageshow', onPageShow)
  }, [])
}
